import { useEffect, useState, useContext } from 'react';
import { Table, Input, Button, Modal, Form, Row, Col, Select } from 'antd';
import { CloudDownloadOutlined, ExclamationCircleOutlined, UpOutlined, DownOutlined, SwapRightOutlined } from '@ant-design/icons';
import utils from '../../../utils';
import http from '../../../Http';
import AddDTUBurning from './AddDTUBurning';
import BurningMonitor from './BurningMonitor';
import { useTranslation } from 'react-i18next';

function DTUBurningList(props) {
    const { t } = useTranslation();
    const setTip = useContext(utils.tipContext);
    const [form] = Form.useForm();

    const [pageNo, setPageNo] = useState(0);
    const [pageSize, setPageSize] = useState(25);
    const [params, setParams] = useState({
        SN: '',
        Version: '',
    })
    const [expand, setExpand] = useState(false);
    const [loading, setLoading] = useState(false);
    const [rows, setRows] = useState([]);
    const [rowTotal, setRowTotal] = useState(0);
    const [showAddBurning, setShowAddBurning] = useState(false);
    const [controlBurningInfo, setControlBurningInfo] = useState({});

    //获取记录列表
    useEffect(() => {
        let active = true;

        (async () => {
            setLoading(true);
            let resp = await http.post("dtu/burning/list", {
                PageNo: pageNo,
                PageSize: pageSize, 
                ...params
            }).then(async (r)=>{
                return await r.json();
            }).catch((e)=>{
                return null;
            });

            if (!active) {
                return;
            }
            
            if (resp === null || resp.code !== 200) {
                setTip({open:true, severity:"error", msg:(resp && resp.msg) ? resp.msg : t("load inverter burning error")});
                setRowTotal(0)
                setRows([]);
                return;
            }

            setRowTotal(resp.data.RowTotal);
            setRows(resp.data.Rows);
            setLoading(false);
        })();

        return () => {
            active = false;
        };

    }, [pageNo, pageSize, params]);

    const handleSearch = () => {
        setPageNo(0);
        const ps = form.getFieldsValue();
        ps.SN = ps.SN || '';
        ps.Version = ps.Version || '';
        setParams(ps)
    }

    //判断烧录进度
    const burnProgress = (v, r, idx) => {
        if (r.FirmwareVersion && r.FirmwareVersion.startsWith("I04")) {
            if (r.Progress == -1) {
                return t('ignored');
            } else if (r.STime == null) {
                return t('to be burned');
            } else if(r.ETime != null) {
                return t('burned');
            } else  {
                return t('burning');
            }
        } else {
            if(r.BurningID == r.BindingID) {
                if(!r.Progress) {
                    return t('to be burned');
                } else if(r.Progress >= r.DataLength) {
                    return t('burned');
                } else {
                    return t('burning');
                }
            }
        }
    }

    //操作
    const renderAction = (v, r, idx) => {
        var btns = [];
        const btnConfirm = <Button key="Confirm" shape="round" onClick={() => { handleConfirm(r, idx) }} type="primary" size="small" style={{ marginRight: "3px" }}>{t('Confirm')}</Button>;
        if (r.FirmwareVersion && r.FirmwareVersion.startsWith("I04")) {
            if (r.Progress == null && r.STime == null) {
                btns.push(btnConfirm)
                btns.push(<Button key="Ignore" shape="round" onClick={() => { handleIgnore(r, idx) }} type="primary" size="small" style={{ marginRight: "3px" }}>{t('Ignore')}</Button>)
            } else if (r.Progress != null && r.Progress != -1 && r.STime != null && r.ETime == null) {
                btns.push(<Button key="Monitor" shape="round" onClick={() => { handleMonitor(r, idx) }} type="primary" size="small" style={{ marginRight: "3px" }}>{t('Monitor')}</Button>)
                btns.push(<Button key="Ignore" shape="round" onClick={() => { handleIgnore(r, idx) }} type="primary" size="small" style={{ marginRight: "3px" }}>{t('Ignore')}</Button>)
            }
        } else {
            if(r.BindingID != r.BurningID) return;
            if(!r.Progress || r.Progress < r.DataLength) {
                btns.push(btnConfirm)
            } 
        }
        return (
            <>{btns}</>
        )
    }

    //执行烧录
    const handleConfirm = async (r, idx) => {
        try {
            var ps = {
                DTUSN: r.SN,
            }
            var url = "dtu/burning/request";
            var resp = null;
            if(r.FirmwareVersion && r.FirmwareVersion.startsWith("I04")) {
                url = "dtu-v2/burning/request";
                ps.SessionID = parseInt(r.BurningID);
                ps.BurnID = r.BurningID.toString();
                ps.FirmwareID = r.FirmwareID.toString();
                resp = await http.postJSON(url, ps
                ).then(async (r) => {
                    return await r.json();
                }).catch((e) => {
                    console.log("[BurningManagement]", e);
                    return null;
                });
            } else {
                ps = {...ps, ...{
                    DTUID: r.DTUID,
                    BurningID: r.BurningID,
                    FirmwareID: r.FirmwareID,
                }};

                resp = await http.post(url, ps
                ).then(async (r) => {
                    return await r.json();
                }).catch((e) => {
                    console.log("[BurningManagement]", e);
                    return null;
                });
            }

            

            if (resp.code !== 200) {
                setTip({ open: true, severity: "error", msg: (resp && resp.msg) ? resp.msg : t("Confirm error") });
                return;
            }

            if(r.FirmwareVersion && r.FirmwareVersion.startsWith("I04")) {
                r.Progress = 0;
                r.STime = new Date().toISOString();
                var rs = [...rows];
                setRows(rs);
            } else {
                //
            }

            setTip({ open: true, severity: "success", msg: t("Confirm success") })
        } catch (e) {
            setTip({ open: true, severity: "error", msg: t("Confirm error") });
        }
    }


    //取消烧录任务
    const handleIgnore = async (r, idx) => {
        try {
            var ps = {
                DTUSN: r.SN,
            }
            var url = "";
            if(r.FirmwareVersion && r.FirmwareVersion.startsWith("I04")) {
                url = "dtu-v2/burning/request";
                ps.SessionID = parseInt(r.BurningID)
                ps.BurnID = "";
                ps.FirmwareID = "";
            } else {
                //
            }

            const resp = await http.postJSON(url, ps
            ).then(async (r) => {
                return await r.json();
            }).catch((e) => {
                console.log("[BurningManagement]", e);
                return null;
            });

            if (resp.code !== 200) {
                setTip({ open: true, severity: "error", msg: (resp && resp.msg) ? resp.msg : t("Confirm error") });
                return;
            }

            if(r.FirmwareVersion && r.FirmwareVersion.startsWith("I04")) {
                r.Progress = -1;
                var rs = [...rows];
                setRows(rs);
            } else {
                //
            }

            setTip({ open: true, severity: "success", msg: t("Confirm success") })
        } catch (e) {
            setTip({ open: true, severity: "error", msg: t("Confirm error") });
        }
    }

    //监控烧录任务
    const handleMonitor = async (r, idx) => {
        if(r.FirmwareVersion && r.FirmwareVersion.startsWith("I04")) {
            setControlBurningInfo({
                visible: true,
                burningID: r.BurningID,
                dataLength: r.DataLength,
                row: r,
            })
        } else {
            //
        }
    }

    //关闭添加烧录任务窗口
    const handleAddingClose = (rs) => {
        setShowAddBurning(false);
        if (!rs) {
            return;
        }

        if (rs instanceof Array && rs.length > 0 ) {
            rs.forEach((r) => {
                if (r.FirmwareVersion && r.FirmwareVersion.startsWith("I04")) {
                    r.BurningID = r.ID;
                    r.STime = null;
                    r.Progress = null;
                }
            });
        }

        document.getElementsByClassName("ant-table-body")[0].scrollTo(0, 0);
        setRows([...(rs instanceof Array ? rs : [rs]), ...rows]);
        setRowTotal(rowTotal+(rs instanceof Array ? rs.length : 1));
    }

    //按下Enter键时进行查找
    const searchByEnter = (e) => { 
        if(e.code == "Enter") {
            handleSearch()
        }
    }

    const handleBurningMonitorCancel = (progress) => {
        if (progress == 100) {
            var rs = [...rows];
            controlBurningInfo.row.Progress = controlBurningInfo.row.DataLength;
            controlBurningInfo.row.ETime = new Date().toISOString();
            setRows(rs);
        }

        setControlBurningInfo({
            visible: false,
        });
    }

    return (
        <div style={{
            height: "100%",
            display: "flex",
            flexDirection: "column",
            padding: 8,
        }}>
            <div style={{
                flex: "0 1 auto",
            }}> 
                <Form 
                    form={form}
                    style={{
                        padding: 24,
                        background: '#fbfbfb',
                        border: '1px solid #d9d9d9',
                        borderRadius: 2
                    }}
                    >
                        <Row gutter={24}>
                            <Col span={8} key="SN">
                                <Form.Item name="SN" label={t("SN")}>
                                    <Input placeholder={t("Enter DTU SN")} onPressEnter={handleSearch} />
                                </Form.Item>
                            </Col>
                            <Col span={8} key="Version">
                                <Form.Item name="Version" label={t("Version")}>
                                    <Input placeholder={t("Enter Firmware Version")} onPressEnter={handleSearch} />
                                </Form.Item>
                            </Col>
                            <Col span={8} style={{ textAlign: 'right' }}>
                                <Button type="primary" shape="round" onClick={handleSearch}>
                                    {t("Search")}
                                </Button>
                                <Button
                                    style={{ margin: '0 8px' }}
                                    shape="round"
                                    onClick={() => {
                                        form.resetFields();
                                    }}
                                >
                                    {t("Clear")}
                                </Button>
                            </Col>
                        </Row>
                    </Form>
            </div>
            <div style={{
                flex: '0 0 auto',
                display: 'flex',
                flexDirection: 'row',
                justifyContent: 'flex-end',
                paddingTop: 8,
            }}>
                <Button type="primary" shape="round" icon={<CloudDownloadOutlined /> } size="middle" style={{marginLeft: 5}} onClick={() => setShowAddBurning(true)}>{t("Add Burning")}</Button>
            </div>
            <div style={{
                flex: "1 1 1px",
                position: "relative",
                overflow: "hidden"
            }}>
                <Table
                    columns={[
                        {
                            title: "",
                            width: 40,
                            fixed: 'left',
                            render: (v, r, idx) => {
                                return (pageNo * pageSize + idx + 1);
                            }
                        },
                        {
                            title: t('DTU SN'),
                            dataIndex: "SN",
                            width: 120,
                            fixed: 'left',
                        },
                        {
                            title: t('Firmware Version'),
                            dataIndex: 'Version',
                            width: 120,
                        },
                        {
                            title: t('DataLength'),
                            dataIndex: 'DataLength',
                            width: 120,
                        },
                        {
                            title: t('Progress'),
                            width: 120,
                            render: burnProgress,
                        },
                        {
                            title: t('Burning Time'),
                            dataIndex: 'STime',
                            width: 120,
                        },
                        {
                            title: t('Note'),
                            dataIndex: 'Note',
                            width: 120,
                        },
                        {
                            title: t('Create Time'),
                            dataIndex: 'CreateTime',
                            width: 120,
                        },
                        {
                            title: t('Action'),
                            width: 160,
                            render: renderAction
                        }
                    ]}
                    style={{height: "100%"}}
                    pagination={{
                        pageSizeOptions: [25,50,100],
                        current: pageNo+1,
                        pageSize: pageSize,
                        total: rowTotal,
                        showSizeChanger: true,
                        showTotal: (total) => {return t("Total {{total}}", {total})},
                        onShowSizeChange: (current, size) => {
                            setPageSize(size);
                        },
                        onChange: (page, pageSize) => {
                            setPageNo(page-1);                                
                        }
                    }}
                    tableLayout="fixed"
                    bordered={true}
                    size="middle"
                    loading={loading}
                    rowKey="ID"
                    dataSource={rows}
                    scroll={{ x: 600, y: true }}
                >
                </Table>
            </div>
            <AddDTUBurning showAddBurning={showAddBurning} onClose={handleAddingClose}
                zIndex={2000} />
                <BurningMonitor 
                    visible={controlBurningInfo.visible}
                    type_="DTU"
                    burningID={controlBurningInfo.burningID}
                    dataLength={controlBurningInfo.dataLength}
                    onCancel={handleBurningMonitorCancel}
                />
        </div>
    )
}

export default DTUBurningList;